import React from "react";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ConstructionIcon from "@mui/icons-material/Construction";
import ViewDayIcon from "@mui/icons-material/ViewDay";

export const items = [
  {
    logo: <CodeIcon />,
    description: "Clients share skill requirement",
  },
  {
    logo: <StorageIcon />,
    description: "Review profiles and/or conduct interviews",
  },
  {
    logo: <StorefrontIcon />,
    description: "Finalise resource & sign agreement",
  },
  {
    logo: <ConstructionIcon />,
    description: "Development",
  },
  {
    logo: <StorefrontIcon />,
    description: "Iterations",
  },
  {
    logo: <ViewDayIcon />,
    description: "Delivery",
  },
  {
    logo: <ViewDayIcon />,
    description: "Release your product",
  },
];
